import { Box, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { StandardList } from "../../../_components/list/standardList.component";
import { StandardListItem } from "../../../_components/list/standardListItem.component";
import { getDate, getDateTime } from "../../../_helpers/dateTime.helper";
import { handleErrorResponse } from "../../../_helpers/handleResponse.helper";
import { ticketHistoryService } from "../../../_services/ticketHistory.service";

export function TicketHistoryList() {

    const { id, ticketType } = useParams<{ id: string, ticketType?: string }>();
    const [data, setData] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const filteredData = data.filter(_data =>
        _data.activity.toLowerCase().includes(searchTerm.toLowerCase()) ||
        _data.userName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    useEffect(() => {
        if (id != null) fetchData();
    }, [id]);

    function fetchData() {
        setIsLoading(true);
        return ticketHistoryService.getAll(id, ticketType)
            .then(
                data => {
                    setData(data);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    }

    return (
        <>
         <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6"></Typography>
                <Box display="flex" alignItems="center" flexGrow={1}>
                    <TextField
                        variant="outlined"
                        size="small"
                        placeholder="Search history..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        fullWidth
                    />
                </Box>
            </Box>

        <StandardList isLoading={isLoading}>
            {(!isLoading && !!data.length) && filteredData.map((_data, index) => (
                <StandardListItem
                    primary={_data.userName}
                    secondary={_data.activity}
                    tertiary={_data.activityDate != null ? getDateTime(_data.activityDate) : ""}
                    key={_data.id}
                />
            ))}

            </StandardList>
        </>
    );

}
